define('SageDotCom/Components/InterceptPanel',["jquery", "SageDotCom/DataLayer/Events/InterceptPanel"],
    function ($, InterceptPanelEvents) {
        let interceptScope = null;
        let modalId = "";

        const exitIntentListener = function (e) {
            if (!e.toElement && !e.relatedTarget && e.clientY < 10) {
                document.removeEventListener("mouseout", exitIntentListener, true);
                showModal();
                new InterceptPanelEvents("sage_ip_loaded", "Intercept Panel", modalId).trigger();

                //set cookie to not show panel in the same session
                document.cookie = `${modalId + "_sage_ip_shown"}=true;path=/`;
            }
        }

        const getCookie = (cname) => {
            const ca = document.cookie.split(";");

            for (const cookie of ca) {
                if (cookie.indexOf(cname + "=") > 0) {
                    return cookie.split("=")[1];
                }
            }
            return null;
        };

        function InterceptPanel(scope, id) {
            interceptScope = scope;
            modalId = id;

            if (getCookie(modalId + "_sage_ip_shown") == null) {
                document.addEventListener("mouseout", exitIntentListener, true);
            }
        }

        function showModal() {
            let $modal = $(".modal", interceptScope);
            $modal = $modal.detach();
            $("body").append($modal);
            $modal.modal("show");
            $modal.modal({ backdrop: "static", keyboard: false });
            $modal.focus();

            $modal.on("hidden.bs.modal", function () {
                new InterceptPanelEvents("sage_ip_dismissed", "Intercept Panel", modalId).trigger();
            });

            const acceptBtn = document.querySelector(".sage-ip-accepted");
            const dismissBtn = document.querySelector(".sage-ip-dismissed");

            //events for buttons
            if (acceptBtn) {
                const acceptBtnText = acceptBtn.textContent || acceptBtn.innerText;
                acceptBtn.addEventListener("click", function (e) {
                    new InterceptPanelEvents("sage_ip_accepted", acceptBtnText, modalId).trigger();
                });
            }

            if (dismissBtn) {
                const dismissBtnText = dismissBtn.textContent || dismissBtn.innerText;
                dismissBtn.addEventListener("click", function (e) {
                    new InterceptPanelEvents("sage_ip_dismissed", dismissBtnText, modalId).trigger();
                });
            }
        }

        InterceptPanel.init = function init(args) {
            return args.IsEditorEditing === true
                ? null
                : new InterceptPanel(args.scope, args.id);
        };

        return InterceptPanel;
    });

